import ReincorporationDataStore from '../../datastores/ReincorporationDataStore';

export default class ReincorporationDataStoreGraphQL
  implements ReincorporationDataStore
{
  async programByCampus() {
    const data: any[] = [];

    return data;
  }

  async registerReincorporation() {
    return {
      requestId: 100000,
      error: null
    };
  }

  async activatePaymentReincorporation() {
    return {
      procedureId: 1033,
      requestId: 2,
      deliveryMode: '',
      career: '',
      error: null
    };
  }
}
